
<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>

    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'4-2'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>
            여행 관리 - 여행상품 {{ $route.query.travel_product_ID === undefined ? '등록' : '수정' }}
          </p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn01" v-on:click="check_form">
              {{ $route.query.travel_product_ID === undefined ? '등록' : '수정' }}
            </button>
          </div>
        </div>

        <div class="Admin_PageDetail">
          <div class="Admin_imgBanner_BoxWrap" style="margin-bottom:20px;">
            <div class="Admin_imgBanner_BoxTit">여행 상품 메인 이미지</div>
            <div class="Admin_imgBanner_Box">
              <div class="Admin_imgBanner_TextBox">
                <p>여행 상품<span class="pointTextRed"> * </span></p>
                <p class="Admin_imgBanner_SubTit">사이즈 : 610 x 420px</p>
              </div>
              <div class="Admin_img_ImgArrayBox">
                <input
                  style="display: none"
                  ref="fileInput"
                  type="file"
                  accept="image/gif, image/jpeg, image/png"
                  @change="changeImage"
                />
                <div
                  v-for="(image, index) in formData.travelProductImages"
                  :key="index"
                  class="Admin_img_ImgArray"
                  @click="promptFileInput"
                >
                  <img
                    :src="image.url || require('@/assets/images/etc/no_image.gif')"
                    alt="'여행상품 이미지 ' + (index + 1)"
                  />
                  <span
                    v-if="image.url"
                    @click.stop="removeImage(index)"
                  >
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='travel_type_division'>여행타입구분<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="travel_type_division"
                v-model="formData.travelTypeDivision"
              >
                <option value='1'>국악와인열차</option>
                <option value='2'>팔도장터열차</option>
                <option value='3'>일반기차여행</option>
                <option value='4'>버스/자유여행</option>
                <option value='5'>섬/제주/해외여행</option>
              </select>
            </div>
          </div>
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='travel_type_ID_use_travel_product'>여행타입<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="travel_type_ID_use_travel_product"
                v-model="formData.travelTypeID"
              >
                <option
                  v-for="item in statusData.travelTypeIDArray"
                  :key="item.travel_type_ID"
                  :value="item.travel_type_ID"
                >
                  {{ item.travel_type_name }}
                </option>
              </select>
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='travel_product_tag'>태그 작성</label>
              <div class="Admin_TagInput_TagWrap">
                <p>
                  - 태그 작성 후 엔터로 추가되며, X 클릭 또는 키보드 DEL키로 삭제<br>
                  - 글자수 최대 10자, 태그 최대 10개 가능
                </p>
                <div class="Admin_TagInput_TagBox">
                  <p class="Admin_TagInput_Tag" v-for="(tag, index) in statusData.tags" :key="index">
                    {{ tag }}
                    <span class="delete-tag" @click="removeTag(index)"></span>
                  </p>
                  <input
                    type="text"
                    id="travel_product_tag"
                    maxLength="10"
                    placeholder="#태그를 입력해주세요"
                    v-model="statusData.tagInput"
                    @keyup.enter="addTag"
                    @keydown.backspace="removeLastTag"
                    />
                </div>
              </div>
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='travel_product_name'>여행상품명<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'travel_product_name'
                maxLength="50"
                placeholder = "50자 내 여행상품명을 입력해 주세요."
                v-model="formData.travelProductName"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.travelProductNameError}}</p>
          </div>
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='travel_product_night'>여행기간(박)<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='number'
                id = 'travel_product_night'
                placeholder = "여행기간(박)을 입력해 주세요."
                v-model="formData.travelProductNight"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.travelProductNightError}}</p>
          </div>
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='travel_product_day'>여행기간(일)<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='number'
                id = 'travel_product_day'
                placeholder = "여행기간(일) 입력해 주세요."
                v-model="formData.travelProductDay"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.travelProductDayError}}</p>
          </div>
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='travel_product_point'>적립포인트<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='number'
                id = 'travel_product_point'
                placeholder = "적립할 포인트를 입력해 주세요."
                v-model="formData.travelProductPoint"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.travelProductPointError}}</p>
          </div>
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='travel_product_minimum_departure'>최소출발인원<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='number'
                id = 'travel_product_minimum_departure'
                placeholder = "최소출발인원을 입력해 주세요."
                v-model="formData.travelProductMinimumDeparture"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.travelProductMinimumDepartureError}}</p>
          </div>
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='travel_product_gather_place'>모이는 장소</label>
              <textarea
                class="Admin_PageDetail_textarea"
                id="travel_product_gather_place"
                maxLength="100"
                rows="5"
                placeholder="모이는장소를 입력해 주세요."
                v-model="formData.travelProductGatherPlace"
              />
              <br>
              <p>{{ formData.travelProductGatherPlace.length }}/100</p>
            </div>
          </div>
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='travel_product_travel_cource'>여행코스</label>
              <textarea
                class="Admin_PageDetail_textarea"
                id="travel_product_travel_cource"
                maxLength="100"
                rows="5"
                placeholder="여행코스를 입력해 주세요."
                v-model="formData.travelProductTravelCource"
              />
              <br>
              <p>{{ formData.travelProductTravelCource.length }}/100</p>
            </div>
          </div>
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='travel_product_included'>포함내역</label>
              <textarea
                class="Admin_PageDetail_textarea"
                id="travel_product_included"
                maxLength="100"
                rows="5"
                placeholder="포함내역을 입력해 주세요."
                v-model="formData.travelProductIncluded"
              />
              <br>
              <p>{{ formData.travelProductIncluded.length }}/100</p>
            </div>
          </div>
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='travel_product_included_not'>불포함내역</label>
              <textarea
                class="Admin_PageDetail_textarea"
                id="travel_product_included_not"
                maxLength="100"
                rows="5"
                placeholder="불포함내역을 입력해 주세요."
                v-model="formData.travelProductIncludedNot"
              />
              <br>
              <p>{{ formData.travelProductIncludedNot.length }}/100</p>
            </div>
          </div>
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='travel_product_info'>안내사항</label>
              <textarea
                class="Admin_PageDetail_textarea"
                id="travel_product_info"
                maxLength="500"
                rows="5"
                placeholder="안내사항을 입력해 주세요."
                v-model="formData.travelProductInfo"
              />
              <br>
              <p>{{ formData.travelProductInfo.length }}/500</p>
            </div>
          </div>
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='travel_product_recommend_status'>추천 여부<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="travel_product_recommend_status"
                v-model="formData.travelProductRecommendStatus"
              >
                <option value='0'>미추천</option>
                <option value='1'>추천</option>
              </select>
            </div>
          </div>
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='travel_product_main_status'>메인화면 표시 여부<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="travel_product_main_status"
                v-model="formData.travelProductMainStatus"
              >
                <option value='0'>미표시</option>
                <option value='1'>표시</option>
              </select>
            </div>
          </div>
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='travel_product_status'>사용 여부<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="travel_product_status"
                v-model="formData.travelProductStatus"
              >
                <option value='1'>사용</option>
                <option value='2'>미사용</option>
              </select>
            </div>
          </div>
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='travel_product_caution'>이용안내</label>
              <custom-textarea
                v-model="formData.travelProductCaution"
                :id="'travel_product_caution'"
              />
            </div>
          </div>
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='travel_product_cancel_refund'>취소/환불규정</label>
              <custom-textarea
                v-model="formData.travelProductCancelRefund"
                :id="'travel_product_cancel_refund'"
              />
            </div>
          </div>
          <!-- 일정표 작성 -->
          <div class="Admin_PageDetail_groupWrap">
            <div class="Admin_PageDetail_groupWrapTit">
              여행 일정표
              <span>아래 버튼을 클릭하여 일정표를 추가하고, 해당 일정표의 상세 시간표를 작성할 수 있습니다.</span>
            </div>
            <div class="Admin_PageDetail_groupBtn">
              <p v-on:click="add_schedule_time">일정표 추가</p>
            </div>

            <div
              class="Admin_PageDetail_groupBox"
              v-for="item in formData.scheduleTimeArray"
              v-if="item.schedule_time_delete_status === 0"
              :key="item.num"
            >
              <div class="Admin_PageDetail_groupBox_Main">
                <div class="Admin_PageDetail_groupBtn02">
                  <p v-on:click="delete_schedule_time(item.num)">
                    일정표 삭제
                  </p>
                </div>
                <div>
                  <div class="Admin_PageDetail_groupBox_Div">
                    <label :for="'schedule_time_order'+item.num">순서<span class="pointTextRed"> * </span></label>
                    <input
                      type='text'
                      :id="'schedule_time_order'+item.num"
                      maxLength="4"
                      placeholder = "순서를 입력해주세요."
                      v-model="item.schedule_time_order"
                    />
                    <p class="Admin_PageDetail_groupBox_ErrorBox">{{item.schedule_time_order_error}}</p>
                  </div>
                  <div class="Admin_PageDetail_groupBox_Div">
                    <label :for="'schedule_time_title'+item.num" class="Admin_PageDetail_BoxDiv_tit">일정표 타이틀<span class="pointTextRed"> * </span></label>
                    <input
                      type='text'
                      :id="'schedule_time_title'+item.num"
                      maxLength="10"
                      placeholder = "타이틀을 10자 내 입력해주세요. (ex.1일차, 기차일정, 여행명 등)"
                      v-model="item.schedule_time_title"
                    />
                    <p class="Admin_PageDetail_groupBox_ErrorBox">{{item.schedule_time_title_error}}</p>
                  </div>
                  <div class="Admin_PageDetail_groupBox_Div">
                    <label :for="'schedule_time_breakfast'+item.num">조식</label>
                    <input
                      type='text'
                      :id="'schedule_time_breakfast'+item.num"
                      maxLength="50"
                      placeholder = "50자 내 조식을 입력해주세요."
                      v-model="item.schedule_time_breakfast"
                    />
                  </div>
                  <div class="Admin_PageDetail_groupBox_Div">
                    <label :for="'schedule_time_lunch'+item.num">중식</label>
                    <input
                      type='text'
                      :id="'schedule_time_lunch'+item.num"
                      maxLength="50"
                      placeholder = "50자 내 중식을 입력해주세요."
                      v-model="item.schedule_time_lunch"
                    />
                  </div>
                  <div class="Admin_PageDetail_groupBox_Div">
                    <label :for="'schedule_time_dinner'+item.num">석식</label>
                    <input
                      type='text'
                      :id="'schedule_time_dinner'+item.num"
                      maxLength="50"
                      placeholder = "50자 내 석식을 입력해주세요."
                      v-model="item.schedule_time_dinner"
                    />
                  </div>
                  <div class="Admin_PageDetail_groupBox_Div">
                    <label :for="'schedule_time_lodging'+item.num">숙소</label>
                    <input
                      type='text'
                      :id="'schedule_time_lodging'+item.num"
                      maxLength="50"
                      placeholder = "50자 내 숙소를 입력해주세요."
                      v-model="item.schedule_time_lodging"
                    />
                  </div>
                </div>
              </div>
              <div class="Admin_PageDetail_groupBox_Sub">
                <div class="Admin_PageDetail_groupBtn03">
                  <p v-on:click="add_schedule_detail_time(item.num)">
                    시간표 추가
                  </p>
                </div>
                <div
                  class="Admin_PageDetail_groupBox_SubInfo"
                  v-for="(schedule_detail_time_item, index) in item.schedule_detail_time"
                  v-if="schedule_detail_time_item.schedule_detail_time_delete_status === 0"
                  :key="schedule_detail_time_item.num"
                >
                  <div :class="['Admin_PageDetail_groupBtn04', getRowColor(index)]">
                    <p v-on:click="delete_schedule_detail_time(item.num, schedule_detail_time_item.num)">
                      시간표 삭제
                    </p>
                  </div>
                  <div  :class="[getRowColor(index)]">
                    <div class="Admin_PageDetail_groupBox_Div">
                      <label :for="'schedule_detail_time_order'+schedule_detail_time_item.num+item.num">시간표 순서<span class="pointTextRed"> * </span></label>
                      <input
                        type='text'
                        :id="'schedule_detail_time_order'+schedule_detail_time_item.num+item.num"
                        maxLength="4"
                        placeholder = "순서를 입력해주세요."
                        v-model="schedule_detail_time_item.schedule_detail_time_order"
                      />
                      <p class="Admin_PageDetail_groupBox_ErrorBox">{{schedule_detail_time_item.schedule_detail_time_order_error}}</p>
                    </div>
                    <div class="Admin_PageDetail_groupBox_Div">
                      <label :for="'schedule_detail_time_title'+schedule_detail_time_item.num">시간표 타이틀</label>
                      <input
                        type='text'
                        :id="'schedule_detail_time_title'+schedule_detail_time_item.num"
                        maxLength="10"
                        placeholder = "타이틀을 10자 내 입력해주세요. (ex. 장소모임, 기차출발, 개별이동 등 생략가능)"
                        v-model="schedule_detail_time_item.schedule_detail_time_title"
                      />
                    </div>
                    <div class="Admin_PageDetail_groupBox_Div">
                      <label :for="'schedule_detail_time'+schedule_detail_time_item.num">시간</label>
                      <input
                        type='text'
                        :id="'schedule_detail_time'+schedule_detail_time_item.num"
                        maxLength="5"
                        placeholder = "시간을 입력해주세요. (ex. 09:30, 14:40 등)"
                        v-model="schedule_detail_time_item.schedule_detail_time"
                      />
                    </div>
                    <div class="Admin_PageDetail_groupBox_Div">
                      <label :for="'schedule_detail_time_content'+item.num+'-'+schedule_detail_time_item.num">내용</label>
                      <CustomTextarea
                        v-model="schedule_detail_time_item.schedule_detail_time_content"
                        :id="'schedule_detail_time_content'+item.num+'-'+schedule_detail_time_item.num"
                        preset="simple"
                      />
                    </div>
                    <div class="Admin_PageDetail_groupBox_Div">
                      <button @click="toggleDetailTimeStatus(schedule_detail_time_item)" class="Admin_PageDetail_groupBoxToggle">
                        {{ schedule_detail_time_item.shcedule_detail_time_toggle_status === 0 ? '토글 사용' : '토글 미사용' }}
                      </button>
                    </div>
                    <div v-if="schedule_detail_time_item.shcedule_detail_time_toggle_status === 1">
                      <div class="Admin_PageDetail_groupBox_Div">
                        <label :for="'schedule_detail_time_toggle_content'+item.num+'-'+schedule_detail_time_item.num">토글 내용</label>
                        <CustomTextarea
                          v-model="schedule_detail_time_item.shcedule_detail_time_toggle_content"
                          :id="'schedule_detail_time_toggle_content'+item.num+'-'+schedule_detail_time_item.num"
                          preset="simple"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button class="Admin_PageHeader_btn01" v-on:click="check_form">
            {{ $route.query.travel_product_ID === undefined ? '등록' : '수정' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import Spiner from '../../Homepage/Section/Spiner.vue'
import CustomTextarea from '../../ETC/CustomTextarea.vue'
import { editorsReady } from '../../ETC/editor/form'

import {
  get_travel_product_one,
  insert_travel_product,
  update_travel_product,
  get_travel_type_use_where
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminTravelProductManagementAdd',
  components: {
    AdminHeader,
    AdminFooter,
    Spiner,
    CustomTextarea
  },
  setup () {
    return {
      formData: ref({
        travelTypeDivision: '1',
        travelTypeID: '',
        travelProductTag: '',
        travelProductName: '',
        travelProductNight: 0,
        travelProductDay: 1,
        travelProductPoint: 0,
        travelProductMinimumDeparture: 0,
        travelProductGatherPlace: '',
        travelProductTravelCource: '',
        travelProductIncluded: '',
        travelProductIncludedNot: '',
        travelProductInfo: '',
        travelProductRecommendStatus: '0',
        travelProductMainStatus: '0',
        travelProductStatus: '1',
        travelProductImages: Array.from({ length: 10 }, () => ({ url: '', file: '' })),
        travelProductCaution: '',
        travelProductCancelRefund: '',
        scheduleTimeArray: []
      }),
      errorData: ref({
        travelProductNameError: '',
        travelProductNightError: '',
        travelProductDayError: '',
        travelProductPointError: '',
        travelProductMinimumDepartureError: ''
      }),
      statusData: ref({
        spinnerStatus: false,
        travelTypeIDArray: [],
        tags: [],
        departureStations: [],
        mountedFirst: false,
        scheduleTimeIndex: 0
      })
    }
  },
  watch: {
    'formData.travelTypeDivision': function (newValue) {
      this.fetchTravelTypeUse(newValue)
    },
    tagInput (newValue) {
      if (!newValue.startsWith('#')) {
        this.statusData.tagInput = '#' + this.statusData.tagInput
      }
    }
  },
  methods: {
    fetchTravelTypeUse (newValue) {
      get_travel_type_use_where(newValue).then(response => {
        if (this.$route.query.travel_product_ID !== undefined && this.statusData.mountedFirst) {
          this.formData.travelTypeID = response[0].travel_type_ID
        }
        if (this.$route.query.travel_product_ID === undefined) {
          this.formData.travelTypeID = response[0].travel_type_ID
        }
        this.statusData.travelTypeIDArray = response
        this.statusData.mountedFirst = true
      })
    },
    addTag () {
      const inputText = this.statusData.tagInput.slice(1).trim()
      if (!inputText) {
        return
      }
      if (this.statusData.tags.includes('#' + inputText)) {
        alert('이미 존재하는 태그입니다.')
      } else if (this.statusData.tags.length >= 10) {
        alert('태그는 최대 10개까지만 추가할 수 있습니다.')
      } else {
        this.statusData.tags.push('#' + inputText)
        this.statusData.tagInput = '#'
      }
    },
    removeLastTag (event) {
      if (this.statusData.tagInput === '#') {
        if (event.keyCode === 8 && this.statusData.tags.length > 0) {
          this.statusData.tags.pop()
          event.preventDefault()
        }
      }
    },
    removeTag (index) {
      this.statusData.tags.splice(index, 1)
    },
    promptFileInput () {
      if (this.formData.travelProductImages.some(image => !image.url)) {
        this.$refs.fileInput.click()
      }
    },
    changeImage (event) {
      const file = event.target.files[0]
      if (file) {
        const reader = new FileReader()
        reader.onload = (e) => {
          const firstEmptyIndex = this.formData.travelProductImages.findIndex(image => !image.url)
          if (firstEmptyIndex !== -1) {
            this.formData.travelProductImages[firstEmptyIndex].url = e.target.result
            this.formData.travelProductImages[firstEmptyIndex].file = file
          }
        }
        reader.readAsDataURL(file)
      }
      event.target.value = ''
    },
    removeImage (index) {
      this.formData.travelProductImages.splice(index, 1)
      this.formData.travelProductImages.push({ url: '', file: '' })
    },
    getRowColor (index) {
      const colors = ['color1', 'color2']
      return colors[index % 2]
    },
    add_schedule_time: function () {
      const newOption = {
        num: this.statusData.scheduleTimeIndex,
        schedule_detail_time_num: 0,
        schedule_time_ID: 0,
        travel_product_ID_use_schedule_time: 0,
        schedule_time_title: '',
        schedule_time_title_error: '',
        schedule_time_breakfast: '',
        schedule_time_lunch: '',
        schedule_time_dinner: '',
        schedule_time_lodging: '',
        schedule_time_order: Math.max(
          0,
          ...this.formData.scheduleTimeArray.map(item => item.schedule_time_order)
        ) + 1,
        schedule_time_order_error: '',
        schedule_time_delete_status: 0,
        schedule_detail_time: []
      }
      this.formData.scheduleTimeArray.push(newOption)
      this.statusData.scheduleTimeIndex++

      this.$nextTick(() => {
        const elementId = `schedule_time_title${newOption.num}`
        const inputElement = document.getElementById(elementId)
        if (inputElement) {
          inputElement.focus()
        }
      })
    },
    delete_schedule_time: function (targetNum) {
      const index = this.formData.scheduleTimeArray.findIndex(option => option.num === targetNum)
      if (index !== -1) {
        this.formData.scheduleTimeArray[index] = {
          ...this.formData.scheduleTimeArray[index],
          schedule_time_delete_status: 1
        }
        this.formData.scheduleTimeArray = [...this.formData.scheduleTimeArray]
      }
    },
    add_schedule_detail_time: function (optionNum) {
      const option = this.formData.scheduleTimeArray.find(o => o.num === optionNum)
      if (!option) {
        alert('시간표가 없습니다.')
        return
      }
      const maxOrder = Math.max(
        0,
        ...option.schedule_detail_time.map(item => item.schedule_detail_time_order)
      )
      const newListNum = option.schedule_detail_time_num++
      const newOptionList = {
        num: newListNum,
        schedule_detail_time_ID: 0,
        schedule_time_ID_use_schedule_detail_time: 0,
        schedule_detail_time_title: '',
        schedule_detail_time: '',
        schedule_detail_time_content: '',
        shcedule_detail_time_toggle_status: 0,
        shcedule_detail_time_toggle_content: '',
        schedule_detail_time_order: maxOrder + 1,
        schedule_detail_time_order_error: '',
        schedule_detail_time_delete_status: 0
      }
      option.schedule_detail_time.push(newOptionList)
      this.$forceUpdate()
      this.$nextTick(() => {
        const element = this.$el.querySelector(`#schedule_detail_time_order${newListNum}${optionNum}`)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
        }
      })
    },
    delete_schedule_detail_time: function (optionNum, listNum) {
      const option = this.formData.scheduleTimeArray.find(o => o.num === optionNum)
      if (option) {
        const list = option.schedule_detail_time.find(l => l.num === listNum)
        if (list) {
          list.schedule_detail_time_delete_status = 1
        } else {
          alert('삭제할 리스트 항목을 찾을 수 없습니다.')
        }
      } else {
        alert('해당하는 시간표을 찾을 수 없습니다.')
      }
      this.$forceUpdate()
    },
    toggleDetailTimeStatus: function (item) {
      item.shcedule_detail_time_toggle_status = item.shcedule_detail_time_toggle_status === 0 ? 1 : 0
      this.$forceUpdate()
    },
    check_form: function () {
      // 업로드 중인 이미지가 본문에서 누락되지 않도록 저장 전에 확인한다.
      if (!editorsReady(this)) return
      let continue_add = true
      this.errorData.travelProductNameError = this.formData.travelProductName ? '' : '여행상품명을 입력해 주세요.'
      this.errorData.travelProductNightError = this.formData.travelProductNight >= 0 ? '' : '여행기간(박)을 올바르게 입력해주세요.'
      this.errorData.travelProductDayError = this.formData.travelProductDay >= 0 ? '' : '여행기간(일)을 올바르게 입력해주세요.'
      this.errorData.travelProductDayError = this.formData.travelProductDay > this.formData.travelProductNight ? '' : '여행기간(일)은 여행기간(박)보다 커야 합니다.'
      this.errorData.travelProductPointError = this.formData.travelProductPoint >= 0 ? '' : '최소출발인원을 올바르게 입력해주세요.'
      this.errorData.travelProductMinimumDepartureError = this.formData.travelProductMinimumDeparture >= 0 ? '' : '최소출발인원을 올바르게 입력해주세요.'
      this.formData.scheduleTimeArray.forEach(element => {
        if (element.schedule_time_delete_status === 0) {
          if (element.schedule_time_title === '') {
            element.schedule_time_title_error = '시간표 타이틀를 입력해 주세요.'
            continue_add = false
          } else {
            element.schedule_time_title_error = ''
          }
          if (element.schedule_time_order === '') {
            element.schedule_time_order_error = '순서를 입력해 주세요.'
            continue_add = false
          } else {
            element.schedule_time_order_error = ''
          }
          element.schedule_detail_time.forEach(element_option_list => {
            if (element_option_list.schedule_detail_time_delete_status === 0) {
              if (element_option_list.schedule_detail_time_order === '') {
                element_option_list.schedule_detail_time_order_error = '순서를 입력해 주세요.'
                continue_add = false
              } else {
                element_option_list.schedule_detail_time_order_error = ''
              }
            }
          })
        }
      })
      this.formData.travelProductTag = JSON.stringify(this.statusData.tags)
      if (
        !this.errorData.travelProductNameError &&
        !this.errorData.travelProductNightError &&
        !this.errorData.travelProductDayError &&
        !this.errorData.travelProductPointError &&
        !this.errorData.travelProductMinimumDepartureError &&
        continue_add
      ) {
        this.statusData.spinnerStatus = true

        if (this.$route.query.travel_product_ID === undefined) {
          insert_travel_product(
            this.formData.travelTypeID,
            this.formData.travelProductTag,
            this.formData.travelProductName,
            this.formData.travelProductNight,
            this.formData.travelProductDay,
            this.formData.travelProductPoint,
            this.formData.travelProductMinimumDeparture,
            this.formData.travelProductGatherPlace,
            this.formData.travelProductTravelCource,
            this.formData.travelProductIncluded,
            this.formData.travelProductIncludedNot,
            this.formData.travelProductInfo,
            this.formData.travelProductRecommendStatus,
            this.formData.travelProductMainStatus,
            this.formData.travelProductStatus,
            this.formData.travelProductImages,
            this.formData.travelProductCaution,
            this.formData.travelProductCancelRefund,
            this.formData.scheduleTimeArray
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('등록이 완료되었습니다.')
            window.location.href = '/AdminTravelProductManagement'
          })
        } else {
          update_travel_product(
            this.$route.query.travel_product_ID,
            this.formData.travelTypeID,
            this.formData.travelProductTag,
            this.formData.travelProductName,
            this.formData.travelProductNight,
            this.formData.travelProductDay,
            this.formData.travelProductPoint,
            this.formData.travelProductMinimumDeparture,
            this.formData.travelProductGatherPlace,
            this.formData.travelProductTravelCource,
            this.formData.travelProductIncluded,
            this.formData.travelProductIncludedNot,
            this.formData.travelProductInfo,
            this.formData.travelProductRecommendStatus,
            this.formData.travelProductMainStatus,
            this.formData.travelProductStatus,
            this.formData.travelProductImages,
            this.formData.travelProductCaution,
            this.formData.travelProductCancelRefund,
            this.formData.scheduleTimeArray
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('수정이 완료되었습니다.')
            window.location.href = '/AdminTravelProductManagement'
          })
        }
      } else {
        alert('입력값을 확인해주세요.')
      }
    }
  },
  mounted () {
    if (this.$route.query.travel_product_ID !== undefined) {
      get_travel_product_one(this.$route.query.travel_product_ID).then((result) => {
        const product = result.travel_product[0]
        this.formData.travelTypeDivision = product.travel_type_division
        this.formData.travelTypeID = product.travel_type_ID_use_travel_product
        this.statusData.tags = JSON.parse(product.travel_product_tag)
        this.formData.travelProductName = product.travel_product_name
        this.formData.travelProductNight = product.travel_product_night
        this.formData.travelProductDay = product.travel_product_day
        this.formData.travelProductPoint = product.travel_product_point
        this.formData.travelProductMinimumDeparture = product.travel_product_minimum_departure
        this.formData.travelProductGatherPlace = product.travel_product_gather_place
        this.formData.travelProductTravelCource = product.travel_product_travel_cource
        this.formData.travelProductIncluded = product.travel_product_included
        this.formData.travelProductIncludedNot = product.travel_product_included_not
        this.formData.travelProductInfo = product.travel_product_info
        this.formData.travelProductRecommendStatus = product.travel_product_recommend_status
        this.formData.travelProductMainStatus = product.travel_product_main_status
        this.formData.travelProductStatus = product.travel_product_status
        this.formData.travelProductCaution = product.travel_product_caution
        this.formData.travelProductCancelRefund = product.travel_product_cancel_refund
        this.formData.travelProductImages = []
        for (let i = 1; i <= 10; i++) {
          let imageUrl = product[`travel_product_img${i}`]
          if (imageUrl) {
            this.formData.travelProductImages.push({
              url: imageUrl,
              file: ''
            })
          } else {
            this.formData.travelProductImages.push({ url: '', file: '' })
          }
        }
        this.formData.scheduleTimeArray = result.schedule_time_rows
        this.formData.scheduleTimeArray.forEach(element => {
          element.schedule_detail_time = []
          let schedule_detail_time_num = 0
          result.schedule_detail_time_rows.forEach(element_schedule_detail_time => {
            if (element.schedule_time_ID === element_schedule_detail_time.schedule_time_ID_use_schedule_detail_time) {
              element_schedule_detail_time.num = schedule_detail_time_num
              element_schedule_detail_time.shcedule_detail_time_toggle_status = element_schedule_detail_time.shcedule_detail_time_toggle_status || 0
              element.schedule_detail_time.push(element_schedule_detail_time)
              schedule_detail_time_num++
              element.schedule_detail_time_num = schedule_detail_time_num
            }
          })
          this.statusData.scheduleTimeIndex = this.formData.scheduleTimeArray.length
        })
      })
    } else {
      this.fetchTravelTypeUse(this.formData.travelTypeDivision)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/TravelManagement/AdminTravelProductManagementAdd.vue